const NewsAPI = require("newsapi");
const newsapi = new NewsAPI(process.env.REACT_APP_NEWS_API);

export default newsapi;
